<template>
<div class="edit-area" v-loading.fullscreen.lock="fullscreenLoading" >
  <div class="container-base fullscreen">
    <h1>
      ヤギプライム基本設定
    </h1>
    <div class="overflow-scroll-x step" ref="step">
      <ol>
        <li v-for="(item, index) in yagiPrimeCards"
          :ref="'steps'"
          :key="item.id"
          :index="index"
          :class="{current:(item.id == currentCardId),
                     over:(index < currentCardIndex)}"
          v-ripple>
          <a href="#"
             @click="goCardTo(item.id);$event.preventDefault()">
            {{ item.title }}
          </a>
        </li>
      </ol>
    </div>
    <v-touch v-bind:enabled="{swipe:true, press:false, pan:false, tap:false, rotate:false, pinch:false}"
      v-on:swipeleft="swipeNextCard"
      v-on:swiperight="swipePrevCard"
      v-bind:swipe-options="{direction:'horizontal'}">
      <div class="cards" v-show="currentCardId">
        
        <!-- <component v-bind:is="buyform"
          ref="editFormat"
          :current-card-id="currentCardId"></component> -->
        <div class="el-main"
          ref="mainViewer">
          <div class="card" v-show="currentCardId == 'step1'">
            <div class="overflow-scroll-y">
                <div class="card-header">
                    <h2>希望の働き方を入力</h2>
                    <p>複数選択可能ですが、新卒と中途は同時に選択する事ができません。また、<span style="color: #e3165c;">登録後の変更はできません。</span></p>
                </div>
            </div>

            <div style="width: 500px; max-width: 100%; margin: 20px auto;">
              <ul style="display: flex; justify-content: space-between; flex-wrap: wrap; margin-bottom: 15px;">
                <li style="border: 2px solid #99B8B3;border-radius: 5px;padding: 10px 0 10px 10px;margin-bottom: 10px;width: 100%;">
                    <el-checkbox v-model="formatData.categoryCareer"
                      :disabled="formatData.categoryNew" >正社員（中途）</el-checkbox>
                </li>
                <li style="border: 2px solid #99B8B3;border-radius: 5px;padding: 10px 0 10px 10px;margin-bottom: 10px;width: 100%;">
                    <el-checkbox v-model="formatData.categoryNew"
                      :disabled="formatData.categoryCareer" >正社員（新卒）</el-checkbox>
                </li>
                <li style="border: 2px solid #99B8B3;border-radius: 5px;padding: 10px 0 10px 10px;margin-bottom: 10px;width: 100%;">
                    <el-checkbox v-model="formatData.categoryParttime" >パート・アルバイト</el-checkbox>
                </li>
                <li style="border: 2px solid #99B8B3;border-radius: 5px;padding: 10px 0 10px 10px;margin-bottom: 10px;width: 100%;">
                    <el-checkbox v-model="formatData.categoryFreelancer" >複業</el-checkbox>
                </li>
              </ul>
            </div>

          </div>
          <div class="card" v-show="currentCardId == 'step2'">

            <div class="overflow-scroll-y">
                <div class="card-header">
                    <h2>希望の条件を入力</h2>
                    <p v-if="formatData.categoryCareer">正社員（中途）のお仕事の希望条件を入力してください</p>
                    <p v-else-if="formatData.categoryNew">正社員（新卒）のお仕事の希望条件を入力してください</p>
                    <p v-else>お仕事の希望条件を入力してください</p>
                </div>
            </div>

            <div style="width: 500px; max-width: 100%; margin: 20px auto;">
              <div class="edit-form-item" v-if="formatData.categoryNew">
                <div class="item-name">学部・学科</div>
                <div class="item-body">
                  <el-select v-model="formatData.department"
                    placeholder="選択してください">
                    <el-option v-for="item in departmentOptions"
                      :key="item"
                      :label="item"
                      :value="item"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="edit-form-item">
                <div class="item-name"><small style="color:red;">※</small>居住地</div>
                <div class="item-body">
                  <el-select v-model="formatData.nowAreaPref"
                    placeholder="選択してください">
                    <el-option v-for="item in prefOptions"
                      :key="item"
                      :label="item"
                      :style="item"
                      :value="item"></el-option>
                  </el-select>
                </div>
                <div class="item-name">希望勤務地</div>
                <div class="item-body">
                  <el-select v-model="formatData.hopeAreaPref"
                    placeholder="選択してください">
                    <el-option v-for="item in prefOptions"
                      :key="item"
                      :label="item"
                      :style="item"
                      :value="item"></el-option>
                  </el-select>
                </div>
                <div class="item-name"><small style="color:red;">※</small>希望業界</div>
                <div class="item-body">
                  <el-select v-model="formatData.hopeIndustry" 
                    placeholder="選択してください">
                    <el-option v-for="(item, index) in hopeIndustryOptions"
                      :key="item"
                      :label="item"
                      :style="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </div>
                <div class="item-name"><small style="color:red;">※</small>希望職種</div>
                <div class="item-body">
                  <el-select v-model="formatData.hopeJobcategory" 
                    placeholder="選択してください"
                    style="left:0;max-width: 100%;">
                    <el-option v-for="(item, index) in hopeJobcategoryOptions"
                    style="width: 100%;"
                      :key="item"
                      :label="item"
                      :style="item"
                      :value="item"></el-option>
                  </el-select>
                </div>
                <div class="item-name"><small style="color:red;">※</small>希望就業時期</div>
                <div class="item-body">
                  <el-select v-model="formatData.hopeWorkingTime" 
                    placeholder="選択してください"
                    style="left:0;max-width: 100%;">
                    <el-option v-for="(item, index) in hopeWorkingTimeOptions"
                    style="width: 100%;"
                      :key="item"
                      :label="item"
                      :style="item"
                      :value="item"></el-option>
                  </el-select>
                </div>
              </div>
            </div>

          </div>
          <div class="card" v-show="currentCardId == 'confirm'">
            <div class="overflow-scroll-y">
              <div class="card-header">
                <h2>入力項目の確認</h2>
              </div>
              <div class="card-content">
                <div class="edit-form">
                  <div class="edit-form-item">
                    <div class="item-name">
                      <h3 class="h3" style="margin: 30px 0 10px;">
                        <span v-if="formatData.categoryCareer">希望の働き方：正社員（中途）</span>
                        <span v-else-if="formatData.categoryNew">希望の働き方：正社員（新卒）</span>
                        <p v-if="formatData.categoryParttime">パート・アルバイト</p>
                        <p v-if="formatData.categoryFreelancer">複業</p>
                      </h3>
                    </div>
                    <div class="item-body" style="margin-left:10px;" v-if="formatData.categoryNew">
                      学部・学科：{{ formatData.department }}
                    </div>
                    <div class="item-body" style="margin-left:10px;">
                      居住地：{{ formatData.nowAreaPref }}
                    </div>
                    <div class="item-body" style="margin-left:10px;">
                      希望勤務地：{{ formatData.hopeAreaPref }}
                    </div>
                    <div class="item-body" style="margin-left:10px;">
                      希望業界：{{ formatData.hopeIndustry }}
                    </div>
                    <div class="item-body" style="margin-left:10px;">
                      希望職種：{{ formatData.hopeJobcategory }}
                    </div>
                    <div class="item-body" style="margin-left:10px;">
                      希望就業時期：{{ formatData.hopeWorkingTime }}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="card" v-show="currentCardId == 'complete'">
            <div class="overflow-scroll-y">
              <div class="card-header">
                <h2>登録が完了しました</h2>
                <div class="edit-form-item" style="text-align:center;padding: 10px 0 30px; font-weight: bold;">
                  仕事を紹介してくれるエージェントからあなたを待っています。早速やりとりして見ましょう！
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="card-pager-nav">
          <div class="pager">
            <el-button v-ripple
              v-if="currentCardId!='confirm'"
              @click="goNextCard"
              :disabled="!isNextCardAvailable"
              type="primary">
              次へ <i class="el-icon-d-arrow-right"></i>
            </el-button>
            <el-button v-ripple
              v-else
              @click="goNextCard"
              :disabled="!isNextCardAvailable || paymentMethod == 'amazon'"
              type="primary">
              上記の内容で設定を行う <i class="el-icon-d-arrow-right"></i>
            </el-button>

            <el-button v-ripple
              v-if="currentCardId!='complete'"
              icon="el-icon-d-arrow-left"
              @click="goPrevCard"
              :type="isNextCardAvailable ? 'text': 'primary'"
              :disabled="!isPrevCardAvailable">
              前へ
            </el-button>
          </div>
        </div>
      </div>
    </v-touch>
  </div>
</div>
</template>
<script>
import basicInfo from '@/components/BasicInfo'
import timeAgo from '@/assets/lib/time-ago-jp'
import _ from '@/assets/lib/my-lodash'
import YagiPrimeSettingCards from '@/assets/formats/yagiprimesetting-cards'
// import YagiPrimeSetting from '@/components/formats/YagiPrimeSetting'
import LoginForms from '@/components/RenewLoginForms'
import firebase from 'firebase/app'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const LAST_SAVE_DATE_SAVE_KEY = 'lastSaveDate'

export default {
  props: {
    formatId: {
      type: String
    },
    preview: {
      type: Boolean,
      default: false
    },
    cardId: {
      type: String
    }
  },
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    return {
      fullscreenLoading: false,
      // buyform: YagiPrimeSetting,
      yagiPrimeCards: YagiPrimeSettingCards,
      formatData: {
        categoryCareer: false,
        categoryNew: false,
        categoryParttime: false,
        categoryFreelancer: false,
        hopeWorkingTime: '',
        nowAreaPref: ''
      },
      departmentOptions:['法学・政策系1', '経済・経営系', '商学系', '社会・福祉系', '国際関係系', '外国語系', '文学系', '教員養成系', '教育系', '家政系', '宗教・神学系', '体育・芸術・音楽系', '商船系', '理系', '医療・保健系', '数理物系', '機械系', '電気・電子・制御系', '情報系', '応用物系', '土木系', '建築系', '生物系', '化学・物質系', '金属系', 'その他理工系', '農業・農学系', '水産系', '畜産・酪農系', '薬学系', '医学・歯学系', '獣医系', '衛生・医療・介護系'],
      graduationYearOptions:['23年卒', '24年卒', '25年卒'],
      hopeIndustryOptions:['IT・通信１', 'ソフトウェア・情報処理', 'インターネット関連・ゲーム・アプリ関連', '機械・産業用装置・電機・OA機器', '自動車・自動車部品・輸送用機器', 'コンピュータ・通信機器・精密機器', '電子部品・半導体', '食品・飲料・たばこ・飼料', '化学・医薬・化粧品', '鉄鋼・非鉄金属・金属製品', '石油・石炭・ゴム・プラスチック', 'ガラス・セラミック・セメント', 'パルプ・紙・紙加工・印刷・印刷関連', '日用品・文具・オフィス用品', '建材・エクステリア', 'インテリア・住宅関連', 'アパレル・服飾関連', 'スポーツ・玩具・ゲーム機器', 'その他メーカー・製造関連', '電気・ガス・石油・水道', '放送（テレビ・ラジオ含む）', '新聞・出版', '広告', 'その他（芸能・エンタテインメント関連等）', '運輸（鉄道・航空・海運・物流等）', '総合商社', '専門商社', '百貨店・スーパー・ドラッグストア・コンビニ・ホームセンター', '通信販売、専門店・その他小売り', '銀行（協同組織金融含む）', '証券', '保険', 'その他金融（クレジット等）', 'リース・レンタル', 'ディベロッパー', '建設・建築設計・ハウスメーカー', '設備関連', 'プラント・プラントエンジニアリング', '不動産取引・不動産賃貸・不動産管理', 'デザイン・芸術関連', 'コンサルティング・マーケティング・調査', 'その他専門・技術サービス', 'ホテル・旅館', '外食', 'その他フード', '理美容・エステ・フィットネスクラブ', '旅行・観光', '家事サービス・クリーニング', '冠婚葬祭', 'その他生活関連サービス', 'アミューズメント・レジャーサービス', '教育関連', '医療・保育・介護、福祉', '環境・リサイクル・廃棄物処理', '整備・修理', '人材サービス', 'その他事業サービス（警備、コールセンター等）', 'その他'],
      hopeJobcategoryOptions:['営業１', '事務・秘書・受付', '経理', '総務人事', 'バイヤー', '法務', '知的財産部門', '企画', 'マーケティング', '宣伝・広報', '経営企画', '経営コンサルタント', '為替ディーラー・トレーダー', '証券アナリスト', '融資・資産運用(ファンドマネージャー等）', 'ファイナンシャルアドバイザー', 'アクチュアリー', 'システムエンジニア・プログラマ', 'Webエンジニア', 'ネットワークエンジニア', 'セキュリティエンジニア', 'インフラ・データエンジニア', 'AIエンジニア', '組み込みエンジニア', 'カスタマーエンジニア', '社内SE・情シス', '研究職（製造系）', '設計開発', '生産・製造', '物流・在庫管理', 'セールスエンジニア', '品質管理', '医療技術', 'MR（医薬情報担当者）', '研究開発（医薬系）', '薬剤師', '栄養士', '福祉士・介護士・ホームヘルパー', '講師・インストラクター', '専門コンサルタント', '建築・土木設計', '施工管理', 'Webプロデューサー・ディレクター', 'Webデザイナー', 'デザイナー', 'ゲームクリエイター', 'ゲームプログラマ', 'データサイエンティスト・アナリスト', '記者・ライター', '編集・制作', '販売・接客', '店長（店舗経営・運営）', 'スーパーバイザー', '農業', '林業', '漁業'],
      prefOptions: ['北海道１', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県', '海外'],
		  basicData: {},
      hopeWorkingTimeOptions: ['1ヶ月以内', '3ヶ月以内', '半年以内', '半年以降'],
      currentCardId: '',
      isMaint:false,
      hopeCareerIndustryOptions:['IT・通信１', 'ソフトウェア・情報処理', 'インターネット関連・ゲーム・アプリ関連', '機械・産業用装置・電機・OA機器', '自動車・自動車部品・輸送用機器', 'コンピュータ・通信機器・精密機器', '電子部品・半導体', '食品・飲料・たばこ・飼料', '化学・医薬・化粧品', '鉄鋼・非鉄金属・金属製品', '石油・石炭・ゴム・プラスチック', 'ガラス・セラミック・セメント', 'パルプ・紙・紙加工・印刷・印刷関連', '日用品・文具・オフィス用品', '建材・エクステリア', 'インテリア・住宅関連', 'アパレル・服飾関連', 'スポーツ・玩具・ゲーム機器', 'その他メーカー・製造関連', '電気・ガス・石油・水道', '放送（テレビ・ラジオ含む）', '新聞・出版', '広告', 'その他（芸能・エンタテインメント関連等）', '運輸（鉄道・航空・海運・物流等）', '総合商社', '専門商社', '百貨店・スーパー・ドラッグストア・コンビニ・ホームセンター', '通信販売、専門店・その他小売り', '銀行（協同組織金融含む）', '証券', '保険', 'その他金融（クレジット等）', 'リース・レンタル', 'ディベロッパー', '建設・建築設計・ハウスメーカー', '設備関連', 'プラント・プラントエンジニアリング', '不動産取引・不動産賃貸・不動産管理', 'デザイン・芸術関連', 'コンサルティング・マーケティング・調査', 'その他専門・技術サービス', 'ホテル・旅館', '外食', 'その他フード', '理美容・エステ・フィットネスクラブ', '旅行・観光', '家事サービス・クリーニング', '冠婚葬祭', 'その他生活関連サービス', 'アミューズメント・レジャーサービス', '教育関連', '医療・保育・介護、福祉', '環境・リサイクル・廃棄物処理', '整備・修理', '人材サービス', 'その他事業サービス（警備、コールセンター等）', 'その他'],
      hopeCareerJobcategoryOptions:['営業１', '事務・秘書・受付', '経理', '総務人事', 'バイヤー', '法務', '知的財産部門', '企画', 'マーケティング', '宣伝・広報', '経営企画', '経営コンサルタント', '為替ディーラー・トレーダー', '証券アナリスト', '融資・資産運用(ファンドマネージャー等）', 'ファイナンシャルアドバイザー', 'アクチュアリー', 'システムエンジニア・プログラマ', 'Webエンジニア', 'ネットワークエンジニア', 'セキュリティエンジニア', 'インフラ・データエンジニア', 'AIエンジニア', '組み込みエンジニア', 'カスタマーエンジニア', '社内SE・情シス', '研究職（製造系）', '設計開発', '生産・製造', '物流・在庫管理', 'セールスエンジニア', '品質管理', '医療技術', 'MR（医薬情報担当者）', '研究開発（医薬系）', '薬剤師', '栄養士', '福祉士・介護士・ホームヘルパー', '講師・インストラクター', '専門コンサルタント', '建築・土木設計', '施工管理', 'Webプロデューサー・ディレクター', 'Webデザイナー', 'デザイナー', 'ゲームクリエイター', 'ゲームプログラマ', 'データサイエンティスト・アナリスト', '記者・ライター', '編集・制作', '販売・接客', '店長（店舗経営・運営）', 'スーパーバイザー', '農業', '林業', '漁業'],
      hopeNewIndustryOptions:['IT・通信１', 'ソフトウェア・情報処理', 'インターネット関連・ゲーム・アプリ関連', '機械・産業用装置・電機・OA機器', '自動車・自動車部品・輸送用機器', 'コンピュータ・通信機器・精密機器', '電子部品・半導体', '食品・飲料・たばこ・飼料', '化学・医薬・化粧品', '鉄鋼・非鉄金属・金属製品', '石油・石炭・ゴム・プラスチック', 'ガラス・セラミック・セメント', 'パルプ・紙・紙加工・印刷・印刷関連', '日用品・文具・オフィス用品', '建材・エクステリア', 'インテリア・住宅関連', 'アパレル・服飾関連', 'スポーツ・玩具・ゲーム機器', 'その他メーカー・製造関連', '電気・ガス・石油・水道', '放送（テレビ・ラジオ含む）', '新聞・出版', '広告', 'その他（芸能・エンタテインメント関連等）', '運輸（鉄道・航空・海運・物流等）', '総合商社', '専門商社', '百貨店・スーパー・ドラッグストア・コンビニ・ホームセンター', '通信販売、専門店・その他小売り', '銀行（協同組織金融含む）', '証券', '保険', 'その他金融（クレジット等）', 'リース・レンタル', 'ディベロッパー', '建設・建築設計・ハウスメーカー', '設備関連', 'プラント・プラントエンジニアリング', '不動産取引・不動産賃貸・不動産管理', 'デザイン・芸術関連', 'コンサルティング・マーケティング・調査', 'その他専門・技術サービス', 'ホテル・旅館', '外食', 'その他フード', '理美容・エステ・フィットネスクラブ', '旅行・観光', '家事サービス・クリーニング', '冠婚葬祭', 'その他生活関連サービス', 'アミューズメント・レジャーサービス', '教育関連', '医療・保育・介護、福祉', '環境・リサイクル・廃棄物処理', '整備・修理', '人材サービス', 'その他事業サービス（警備、コールセンター等）', 'その他'],
      hopeNewJobcategoryOptions:['営業１', '事務・秘書・受付', '経理', '総務人事', 'バイヤー', '法務', '知的財産部門', '企画', 'マーケティング', '宣伝・広報', '経営企画', '経営コンサルタント', '為替ディーラー・トレーダー', '証券アナリスト', '融資・資産運用(ファンドマネージャー等）', 'ファイナンシャルアドバイザー', 'アクチュアリー', 'システムエンジニア・プログラマ', 'Webエンジニア', 'ネットワークエンジニア', 'セキュリティエンジニア', 'インフラ・データエンジニア', 'AIエンジニア', '組み込みエンジニア', 'カスタマーエンジニア', '社内SE・情シス', '研究職（製造系）', '設計開発', '生産・製造', '物流・在庫管理', 'セールスエンジニア', '品質管理', '医療技術', 'MR（医薬情報担当者）', '研究開発（医薬系）', '薬剤師', '栄養士', '福祉士・介護士・ホームヘルパー', '講師・インストラクター', '専門コンサルタント', '建築・土木設計', '施工管理', 'Webプロデューサー・ディレクター', 'Webデザイナー', 'デザイナー', 'ゲームクリエイター', 'ゲームプログラマ', 'データサイエンティスト・アナリスト', '記者・ライター', '編集・制作', '販売・接客', '店長（店舗経営・運営）', 'スーパーバイザー', '農業', '林業', '漁業'],
      masterJsonUrl:'https://asia-northeast1-varuna-staging.cloudfunctions.net/get_master_data'

    }
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    previewDialogStyleObject: function () {
      if (this.previewDialogVisible) {
        return {
          visibility: 'visible',
          height: 'auto'
        }
      } else {
        return {
          visibility: 'hidden',
          overflow: 'hidden',
          height: 0
        }
      }
    },
    isDevelopment: function () {
      return process.env.NODE_ENV === 'development'
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    firstCardId: function () {
      console.error(this.yagiPrimeCards[0].id)
      return this.yagiPrimeCards[0].id
    },
    isNextCardAvailable: function () {
      if (!this.currentCardId) return
      return this.currentCardIndex + 1 < this.yagiPrimeCards.length
    },
    isPrevCardAvailable: function () {
      if (!this.currentCardId) return
      return this.currentCardIndex > 0
    },
    currentCardIndex: function () {
      if (!this.currentCardId) return -1
      let key, card
      for (key in this.yagiPrimeCards) {
        card = this.yagiPrimeCards[key]
        if (this.currentCardId === card.id) {
          return Number(key)
        }
      }
      return -1
    },
    currentCardTitle: function () {
      if (!this.currentCardId) return ''
      return this.yagiPrimeCards[this.currentCardIndex].title
    },
    currentCardPreviewJumpId: function () {
      if (!this.currentCardId) return ''
      return this.yagiPrimeCards[this.currentCardIndex].previewJumpId
    },
    nextCardLabel: function () {
      if (this.isNextCardAvailable) {
        return this.yagiPrimeCards[this.currentCardIndex + 1].title
      }
      return ''
    },
    prevCardLabel: function () {
      if (this.isPrevCardAvailable) {
        return this.yagiPrimeCards[this.currentCardIndex - 1].title
      }
      return ''
    }
  },
  methods: {
    cardIdExists: function (cardId) {
      for (const key in this.yagiPrimeCards) {
        if (this.yagiPrimeCards[key].id === cardId) {
          return true
        }
      }
      return false
    },
    changePaymentMethod: function (pmethod) {
      this.paymentMethod = pmethod
    },
    goFirstCard: function () {
      this.goCardTo(this.firstCardId)
    },
    goCurrentCard: function () {
      // this.previewDialogVisible = false
      // if (this.currentCardId == 'rirekisho') {
      //   this.$refs.editFormat.setLetterInnerHtml()
      //   this.isDisplayedRirekishoPreview = true
      // } else if (this.currentCardId == 'letter') {
      //   this.$refs.editFormat.setCheckLetter()
      // } else if (this.currentCardId == 'keirekisho') {
      //   this.$refs.editFormat.setRirekishoInnerHtml()
      // } else if (this.currentCardId == 'payment') {
      //   this.$refs.editFormat.setRirekishoInnerHtml()
      //   this.$refs.editFormat.setKeirekishoInnerHtml()
      //   this.$refs.editFormat.setAddressDataStaffName()
      //   console.error(this.rirekishoHTMLData)
      //   if (!this.isDisplayedRirekishoPreview) {
      //     this.$message({
      //       message: '履歴書のプレビューをご確認ください',
      //       type: 'error'
      //     })
      //     this.goCardTo('rirekisho')
      //   }

      // }
      this.$router.push({
        name: 'yagiPrimeCard',
        params: {
          cardId: this.currentCardId
        }
      })
      
      if (this.formatData.categoryNew ) {
        this.hopeIndustryOptions = this.hopeNewIndustryOptions
        this.hopeJobcategoryOptions = this.hopeNewJobcategoryOptions
      } else {
        this.hopeIndustryOptions = this.hopeCareerIndustryOptions
        this.hopeJobcategoryOptions = this.hopeCareerJobcategoryOptions

      }
      // this.$refs.editFormat.setPreviewScale()

      // this.$refs.editFormat.$refs.previewLetterFormat.checkValid()
      // this.$refs.editFormat.$refs.previewRirekishoFormat.checkValid()
      // console.error("this.$refs.editFormat.$refs.previewLetterFormat.checkValid()")

      // this.$eventHub.$emit('deactivate-history-item')
      // this.$eventHub.$emit('card-changed', this.currentCardId)
    },
    getPreviewRirekishoFormat: function () {
      // console.error(this.$refs.editFormat.$refs.previewRirekishoFormat.$el.innerHTML)
      return this.$refs.editFormat.$refs.previewRirekishoFormat.$el.innerHTML
    },
    scrollToCurrentStep: function () {
      this.$nextTick(function () {
        if (this.currentCardIndex < 0) {
          return
        }
        this.$refs.steps[this.currentCardIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'center'
        })
      })
    },
    goCardTo: function (cardId) {
      if (!this.cardIdExists(cardId)) {
        this.goFirstCard()
        return
      }
      if (cardId == 'complete') {
        return
      }
      this.currentCardId = cardId
      this.goCurrentCard()
      this.scrollToCurrentStep()
    },
    goNextCard: function () {
      if (!this.$firebase.isAuthenticated) {
        this.$eventHub.$emit('open-loginform-dialog', this.formatId, 'save')
      }
      if (this.isNextCardAvailable) {
        var isCheck = false
        if (this.currentCardId == 'step1') {
          if (this.formatData.categoryCareer || this.formatData.categoryNew ||
           this.formatData.categoryParttime || this.formatData.categoryFreelancer) {
            isCheck = true
          } else {
            this.$message({
              duration: 2000,
              message: '働き方を１つ以上を選択してください。',
              type: 'error'
            })
          }
        } else if (this.currentCardId == 'step2') {
          if (!this.formatData.hopeAreaPref) {
            this.$message({
              duration: 2000,
              message: '希望勤務地を選択してください。',
              type: 'error'
            })
            isCheck = false
          } else {
            if (!this.formatData.hopeIndustry) {
              this.$message({
                duration: 2000,
                message: '希望業界を選択してください。',
                type: 'error'
              })
              isCheck = false
            } else {
              if (!this.formatData.hopeJobcategory) {
                this.$message({
                  duration: 2000,
                  message: '希望職種を選択してください。',
                  type: 'error'
                })
                isCheck = false
              } else {
                if (!this.formatData.hopeWorkingTime) {
                  this.$message({
                    duration: 2000,
                    message: '希望就業時期を選択してください。',
                    type: 'error'
                  })
                  isCheck = false
                } else {
                  isCheck = true
                }
              }
            }
          }
          
        } else if (this.currentCardId == 'confirm') {
          if (this.formatData.categoryCareer || this.formatData.categoryNew ||
           this.formatData.categoryParttime || this.formatData.categoryFreelancer) {
            if (!this.formatData.hopeAreaPref) {
              this.$message({
                duration: 2000,
                message: '希望勤務地を選択してください。',
                type: 'error'
              })
              isCheck = false
            } else {
              if (!this.formatData.hopeIndustry) {
                this.$message({
                  duration: 2000,
                  message: '希望業界を選択してください。',
                  type: 'error'
                })
                isCheck = false
              } else {
                if (!this.formatData.hopeJobcategory) {
                  this.$message({
                    duration: 2000,
                    message: '希望職種を選択してください。',
                    type: 'error'
                  })
                  isCheck = false
                } else {
                  if (!this.formatData.hopeWorkingTime) {
                    this.$message({
                      duration: 2000,
                      message: '希望就業時期を選択してください。',
                      type: 'error'
                    })
                    isCheck = false
                  } else {
                    isCheck = true
                  }
                }
              }
            }
          } else {
            this.$message({
              duration: 2000,
              message: '働き方を１つ以上を選択してください。',
              type: 'error'
            })
          }
          
        }
        
        if (isCheck) {
          this.currentCardId = this.yagiPrimeCards[this.currentCardIndex + 1].id
          this.goCurrentCard()
          this.scrollToCurrentStep()
        }
      }
    },
    goPrevCard: function () {
      if (this.isPrevCardAvailable) {
        this.currentCardId = this.yagiPrimeCards[this.currentCardIndex - 1].id
        this.goCurrentCard()
        this.scrollToCurrentStep()
      }
    },
    gotoBasic: function () {
      // this.goCardTo('basic')
    },
    goDownloadCard: function () {
      // this.goCardTo('output')
    },
    swipeNextCard: function () {
      if (this.$deviceLib.isMobileDevice) {
        this.goNextCard()
      }
    },
    swipePrevCard: function () {
      if (this.$deviceLib.isMobileDevice) {
        this.goPrevCard()
      }
    },
    setPreviewScaleDebounce: function (e) {
      _.debounce(this.setPreviewScale, 1000)
    },
    loadingOn: function() {
      this.fullscreenLoading = true
    },
    inputCheck: function () {
      const app = this

      if (app.isMaint) {
        app.$message({
          message: '以下の日時においてヤギの宅配便サービスの休止を予定しています。【利用一時休止期間】11/1 12:00 〜  11/7 18:00',
          type: 'error'
        })
        return false
      }
      if (!this.$refs.editFormat.formatData.addressData_postNumber) {
        app.$message({
          message: '送付先の郵便番号を入力してください',
          type: 'error'
        })
        return false
      } 
      if (!this.$refs.editFormat.formatData.addressData_address1) {
        app.$message({
          message: '送付先の都道府県・市区町村・番地を入力してください',
          type: 'error'
        })
        return false
      } 
      if (!this.$refs.editFormat.formatData.addressData_companyName) {
        app.$message({
          message: '送付先の会社名を入力してください',
          type: 'error'
        })
        return false
      } 
      // if (!this.$refs.editFormat.formatData.addressData_staffName) {
      //   app.$message({
      //     message: '送付先の担当者名を入力してください',
      //     type: 'error'
      //   })
      //   return
      // } 
      if (!this.$refs.editFormat.formatData.from_name) {
        app.$message({
          message: '差出人名を入力してください',
          type: 'error'
        })
        return false
      } 
      if (!this.$refs.editFormat.formatData.from_post) {
        app.$message({
          message: '差出人の郵便番号を入力してください',
          type: 'error'
        })
        return false
      } 
      if (!this.$refs.editFormat.formatData.from_address1) {
        app.$message({
          message: '差出人の住所を入力してください',
          type: 'error'
        })
        return false
      } 
      if (this.paymentMethod == 'card') {
        this.$refs.editFormat.$refs.stripeCardElememt.submit()
      } else if (this.paymentMethod == 'paypay') {
        
      } else {
        if (!this.$refs.editFormat.formatData.ecCode) {
          app.$message({
            message: 'コードを入力してください',
            type: 'error'
          })
          return false
        }

      }
      return true
    },
    authStateChanged: async function () {
      const app = this
      this.$axios
        .get(this.$varuna.endPoints.isSubscribed + this.$firebase.user.uid + '/', null, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.is_subscribed)
          if (!response.data.is_subscribed) {
            app.$router.push('/mypage/yagiprime')
          }
          
        })
        .catch(function (error) {
          
        }).finally(function () {
          app.fullscreenLoading = false
        })
      // const urlParams = new URLSearchParams(window.location.search);
      // var from_page = urlParams.get("frompage");
      // if (from_page) {
      //   this.$router.push('/format/' + from_page + '/edit/output')
      // } else {
      //   this.$router.push('/mypage')
      // }
      // console.log('new login created')
    }
  },
  watch: {
    'cardId': function () {
      this.currentCardId = this.cardId
      if (this.currentCardIndex < 0) {
        this.goFirstCard()
      }
    },
    previewTabActive: function () {
      this.setPreviewScale()
    }
  },
  created: function () {
    const app = this

    this.$axios.get(this.masterJsonUrl)
        .then(function (response) {
          console.error("response.data")
          console.error("response.data")
          console.error(response.data)
          app.departmentOptions = response.data.departmentOptions
          app.hopeNewIndustryOptions = response.data.graduate.industries
          app.hopeNewJobcategoryOptions = response.data.graduate.job_types
          app.hopeCareerIndustryOptions = response.data.mid_career.industries
          app.hopeCareerJobcategoryOptions = response.data.mid_career.job_types
          app.prefOptions = response.data.prefectures

          console.error("response.data")
          console.error("response.data")
        })
        .catch(function (error) {
        })
  },
  mounted: function () {
    if (this.$route.query.merchant_payment_id) {
      this.fullscreenLoading = true
      this.complatePayPay(this.$route.query.merchant_payment_id)
    } else {
      if (this.currentCardIndex < 0) {
        // this.goFirstCard()
        this.goCurrentCard()
      }
    }
    console.error(this.currentCardId)
    console.error(this.cardId)
    this.scrollToCurrentStep()
  },
  beforeMount: function () {
    this.$eventHub.$on('firebase-initialized', this.authStateChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('firebase-initialized', this.authStateChanged)
  }
}
</script>
